const RESOURCE_NAME = '/xroutes-waypoints';
// import axios from "@/api/http-auth";
import config from "@/config";
const baseURL = config.api.baseURL

export default axios => ({
    getAll(routeId, calculated_route_id, params) {
        let url = `${RESOURCE_NAME}`;
        if(routeId && calculated_route_id) url = `xroutes/${routeId}/calculated/${calculated_route_id}/waypoints`;
        return axios.get(url, {params, baseURL});
    },
    find(id, params) {
        return axios.get(`${RESOURCE_NAME}/${id}`, {params, baseURL});
    },
    create(data, params) {
        return axios.post(`${RESOURCE_NAME}`, data, {params, baseURL});
    },
    update(id, data, params) {
        return axios.put(`${RESOURCE_NAME}/${id}`, data, {params, baseURL});
    },
    addWaypointToRoute(routeId, calculated_route_id, id, data, params) {
        return axios.post(`xroutes/${routeId}/calculated/${calculated_route_id}/waypoints/add-waypoint/${id}`, data, {params, baseURL});
    },
    removeWaypointToRoute(routeId, calculated_route_id, id, data, params) {
        return axios.post(`xroutes/${routeId}/calculated/${calculated_route_id}/waypoints/remove-waypoint/${id}`, data, {params, baseURL});
    },
});